import { AxiosProgressEvent } from 'axios';

export const getUploadProgress = (
    progressEvent: AxiosProgressEvent
): number => {
    return Math.round(
        (progressEvent.loaded * 100) / (progressEvent.total || 1)
    );
};
